<template>
  <el-row
    :gutter="10"
    class="receivable-filters">
    <el-col
      :md="8"
      class="form-group top_search">
      <el-card>
        <zee-receivables-search></zee-receivables-search>
      </el-card>
    </el-col>
    <el-col :md="7">
      <el-card>
        <zee-receivables-filter></zee-receivables-filter>
      </el-card>
    </el-col>
    <el-col :md="9">
      <el-card>
        <zee-receivables-by-date></zee-receivables-by-date>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import zeeReceivablesSearch from './partials/ReceivablesSearch.vue';
import zeeReceivablesFilter from './partials/ReceivablesFilter.vue';
import zeeReceivablesByDate from './partials/ReceivablesByDate.vue';

export default{
  components: {
    zeeReceivablesSearch,
    zeeReceivablesFilter,
    zeeReceivablesByDate,
  },
};
</script>

<style lang="scss" scoped>
.receivable-filters{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/partials/receivables-filters/ReceivablesFilters.vue